import * as Yup from 'yup';

export const createResearchKpiGroupValidationSchema = Yup.object().shape({
  name: Yup.string().required('researchKpiGroup.validationErrors.nameRequired'),
  cost: Yup.number().required('researchKpiGroup.validationErrors.costRequired').nullable(),
  appliedYear: Yup.number()
    .required('researchKpiGroup.validationErrors.appliedYearRequired')
    .nullable(),
});

export const createResearchKpiValidationSchema = Yup.object().shape({
  name: Yup.string().required('researchKpi.validationErrors.nameRequired'),
  englishName: Yup.string().required('researchKpi.validationErrors.englishNameRequired'),
  researchKpiGroupId: Yup.string().required(
    'researchKpi.validationErrors.researchKpiGroupRequired'
  ),
});
